export default "__VITE_ASSET__tF0TMy6C__"